import React from 'react';

import TroubleshootingContainer from './TroubleshootingContainer';
import { TroubleshootingDetail } from './TroubleshootingDetail';

const TroubleshootingPage: React.FC = () => (
    <TroubleshootingContainer.Provider>
        <TroubleshootingDetail/>
    </TroubleshootingContainer.Provider>
);
export default TroubleshootingPage;
